module.exports = __webpack_public_path__ + "img/pinActive.2e550abe.svg";